export const dashBetas = [

    'febrafar-inovacao',
    'ultrapopular-fernandopolis',
    'grupo-mauri',
    'redeinova-solucaofarma',
    'vida-sao-leopoldo',
    'vida-cerro-largo',
    'drogaria-primavera',
    'inova-conceicao',
    'vendas',
    'farmaefarma-sorriso',
    'farmaefarma-foppa-zanella',
    'william',
    'farmaefarma-expansao-2',
    'drogaria-drogafarto',
    'farmacias-brava',
    'comercial',
    'pedbot-avisos',
    'rede-bem-menezes',
    'ultrafarma-manoel-gaya12',
    'certifica-minas',
    'cs',
    'vendas-beta',
    'unimar-presencial',
    'farmelhor-hortolandia',
    'drogarede',
    'rm-farma',
    'drogaria-sao-pedro-juvenal',
    'saude-farma-comercio',
    'suporte-pedbot',
    'nossa-farma',
    'multidrogas-birigui',
    'farmacias-brasileira-forquilha',
    'fortini',

];
  
